"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Container = ({ children, className }) => {
    return react_1.default.createElement("div", { className: (0, classnames_1.default)('container mx-auto px-4 lg:px-0', className) }, children);
};
exports.Container = Container;
